import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory } from 'react-router-dom';
import { getCurrentLanguage } from "../assets/js/functions";
import '../assets/scss/app.scss';

import Intro from "../views/Intro";
import Home from "../views/Home";
import Info from "../views/Info";
import View from "../views/View";

const App = () => {

    const [path, setPath] = useState(null);
    const history = useHistory();
    const [language] = useState(getCurrentLanguage());

    useEffect(() => {
        setPath(history.location.pathname)
    }, [history.location.pathname, language])

    return (
        <>
            <Switch>
                <Route exact path={'/'} render={props => <Intro/>} />
                <Route exact path={'/home'} render={props => <Home/>} />
                <Route exact path={'/info'} render={props => <Info/>} />
                <Route exact path={'/:group(acompanyant|empatitzant|ensenyant|reconfortant|escoltant|respectant|ajudant)/:expand(declarations)?/:gallery(gallery)?'} render={props => <View {...props}/>} />
                <Route exact path={'/:group(acompanyant|empatitzant|ensenyant|reconfortant|escoltant|respectant|ajudant)/:id/:expand(declarations)?/:gallery(gallery)?'} render={props => <View {...props}/>} />
                <Route exact path={'*'} render={props => <Intro/>} />
            </Switch>
        </>
    );
}

export default App;
